<template lang="pug">
div
	p U wordt doorverwezen ...
</template>

<script>
import cookies from 'js-cookie';

export default {
	name: 'InsuranceInstructor',
	nuxtI18n: {
		paths: {
			'nl-NL': '/verzekering/skileraar/:code'
		}
	},
	layout: 'default',
	asyncData({ params }) {
		let affiliate = '';
		if (params.code) affiliate = params.code;
		return { affiliate };
	},
	mounted() {
		cookies.set('skiinstructor-affiliate', this.affiliate);
		this.$router.push(
			this.localePath({
				name: 'verzekering-doorlopend-calculate'
			})
		);
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	scrollToTop: true
};
</script>
